export const getIsVerified = () => {
  return localStorage.getItem('isVerified') === 'true';
}

export const setIsVerified = (value) => {
  localStorage.setItem('isVerified', String(value));
}

export const getIsFillProfile = () => {
  return localStorage.getItem('isFillProfile') === 'true';
}

export const setIsFillProfile = (value) => {
  localStorage.setItem('isFillProfile', String(value));
}